import { useCallback, useEffect, useState } from 'react';
import { fetchQuizRuns, type QuizRun, type QuizRunHistory } from '@/lib/api/quiz';

export function useQuizRuns(slug: string | null) {
  const [data, setData] = useState<QuizRunHistory | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const refetch = useCallback(async () => {
    if (!slug) {
      setData(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await fetchQuizRuns(slug);
      setData(result);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    runs: (data?.runs || []) as QuizRun[],
    bestScore: data?.best_score_pct ?? 0,
    trend: data?.trend ?? 0,
    runsCount: data?.runs_count ?? 0,
    loading,
    error,
    refetch,
  };
}
